/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The data returned after a successful signup.
 * @export
 * @interface SignupMachineResponse
 */
export interface SignupMachineResponse {
    /**
     * The tenant idt.
     * @type {string}
     * @memberof SignupMachineResponse
     */
    tenantId: string;
    /**
     * The api key for the newly created tenant.
     * @type {string}
     * @memberof SignupMachineResponse
     */
    apiKey: string;
}

/**
 * Check if a given object implements the SignupMachineResponse interface.
 */
export function instanceOfSignupMachineResponse(value: object): value is SignupMachineResponse {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
    return true;
}

export function SignupMachineResponseFromJSON(json: any): SignupMachineResponse {
    return SignupMachineResponseFromJSONTyped(json, false);
}

export function SignupMachineResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupMachineResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenant_id'],
        'apiKey': json['api_key'],
    };
}

export function SignupMachineResponseToJSON(json: any): SignupMachineResponse {
    return SignupMachineResponseToJSONTyped(json, false);
}

export function SignupMachineResponseToJSONTyped(value?: SignupMachineResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant_id': value['tenantId'],
        'api_key': value['apiKey'],
    };
}

